import { render, staticRenderFns } from "./dictionariesAd.vue?vue&type=template&id=3df37a7e&scoped=true&"
import script from "./dictionariesAd.vue?vue&type=script&lang=js&"
export * from "./dictionariesAd.vue?vue&type=script&lang=js&"
import style0 from "./dictionariesAd.vue?vue&type=style&index=0&id=3df37a7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df37a7e",
  null
  
)

export default component.exports